import { renderClassName } from "@/utils/renderClassName";

type GradientLightTextProps = {
  element: "h1" | "h2" | "h3" | "p" | "span";
  classNames?: string;
  isGrayGradient?: boolean;
  children: React.ReactNode;
  onlyShowGradientOnTablet?: boolean;
};

const GradientLightText = ({
  element,
  classNames,
  isGrayGradient,
  onlyShowGradientOnTablet,
  children,
}: GradientLightTextProps) => {
  const Element = element || "div";

  return (
    <Element
      className={renderClassName("light-gradient", classNames)
        .concat(onlyShowGradientOnTablet ? " light-gradient--tablet" : "")
        .concat(isGrayGradient ? " light-gradient--gray" : "")
        .trim()}
    >
      {children}
    </Element>
  );
};

export default GradientLightText;
